<template>
	<div>
		<PageHeader />
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left" />
				<div class="section__info__right">
					<button
						@click="csvDown"
						class="section__info__items btn-excel"
						v-text="'CSV 다운로드'"
					/>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th
							v-for="(th, idx) in thList"
							:key="idx"
							v-text="th"
						/>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(list, idx) in listBundle" :key="idx">
						<td
							v-for="(item, idx2) in list"
							:key="`${idx}${idx2}`"
							v-text="item"
						/>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import moment from 'moment';
	import util from '@/util';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';

	export default {
		name: 'PushStatisticsDetail',
		components: {
			PageHeader,
			ManagingSection,
		},
		data() {
			return {
				thList: ['회원ID', '닉네임', 'OS', '경로', '생성일'],
				lastUrl: '',
				listBundle: null,
				idNoti: this.$route.params.idNoti,
			};
		},
		methods: {
			async setList() {
				try {
					const {
						config,
						data: {
							messageRegisterLogInfo: { messageRegisterLogList },
						},
					} = await this.$axiosAdmin2.get(
						`/api/tracking/message/${this.idNoti}`
					);
					this.lastUrl = config.url;
					this.listBundle = messageRegisterLogList.map(item => [
						item.idRegister,
						item.nickName,
						item.os,
						item.path === 'message_box' ? '알림함' : '푸시',
						moment(item.createdAt, 'X').format(
							'YYYY-MM-DD HH:mm:ss'
						),
					]);
				} catch (err) {
					console.error(err);
					alert(
						'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			csvDown() {
				const rows = [...this.listBundle];
				const title = `유저별 푸시/알림함 열람 시간(${this.idNoti})_${Date.now()}`;
				util.getCsv(
					[rows],
					[title],
					[this.thList],
					title,
					this.lastUrl
				);
			},
		},
		created() {
			this.setList();
		},
	};
</script>
